<template>
  <a-modal
    :bodyStyle="{'padding-top':'0px'}"
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
  >
    <a-tabs>
      <a-tab-pane tab="微信扫码充值" key="1">
        <a-alert v-if="!independent" message="如果遇到有问题，联系客服QQ：11726691" type="info" />
        <div class="weixin-pay-contaienr">
          <a-card hoverable :bodyStyle="{'padding':'0','width':'200px','height':'200px'}">
            <vue-qr :text="qrSrc" :size="200" :dotScale="1"></vue-qr>
          </a-card>
        </div>
      </a-tab-pane>
    </a-tabs>
    
    <a-card hoverable style="width: 100%">
      <a-card-meta title="本软件已对接【粮仓】提现系统" description="请尽快迁移至更加安全、稳定、高效的粮仓系统，官网：http://www.liangcang.net.cn">
        <a-avatar
          slot="avatar"
          src="http://e.liangcang.net.cn/logo.png"
        />
      </a-card-meta>
    </a-card>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSeccess">充值完成</a-button>
    </template>
  </a-modal>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false
    }
  },
  computed: {
    qrSrc() {
      return `http://trade8.ciwuapp.com/api/v1/recharge?id=N0000${this.currentRobotId}`
    },
    independent() {
      return this.$store.state.brand.independent
    }
  },
  created() {},
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSeccess() {
      this.visible = false
      this.$emit('ok')
    }
  }
}
</script>
<style lang="less">
.weixin-pay-contaienr {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
